import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconMicrophone = _resolveComponent("IconMicrophone")
  const _component_NcIconSvgWrapper = _resolveComponent("NcIconSvgWrapper")

  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["volume-indicator-wrapper", { overload: $options.hasOverload }]),
    style: _normalizeStyle({ height: $props.size + 'px', width: $props.size + 'px' })
  }, [
    _createElementVNode("span", {
      class: "volume-indicator volume-indicator-primary",
      style: _normalizeStyle({ height: $options.iconPrimaryHeight + 'px' })
    }, [
      ($props.audioEnabled)
        ? (_openBlock(), _createBlock(_component_IconMicrophone, {
            key: 0,
            size: $props.size,
            "fill-color": $props.primaryColor
          }, null, 8, ["size", "fill-color"]))
        : (_openBlock(), _createBlock(_component_NcIconSvgWrapper, {
            key: 1,
            inline: "",
            svg: $setup.IconMicrophoneOffOutline,
            size: $props.size,
            style: _normalizeStyle({ color: $props.primaryColor })
          }, null, 8, ["svg", "size", "style"]))
    ], 4),
    ($props.audioPreviewAvailable)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(["volume-indicator volume-indicator-overlay", { 'volume-indicator-overlay-mute': !$props.audioEnabled }]),
          style: _normalizeStyle({ height: $options.iconOverlayHeight + 'px' })
        }, [
          ($props.audioEnabled)
            ? (_openBlock(), _createBlock(_component_IconMicrophone, {
                key: 0,
                size: $props.size,
                "fill-color": $props.overlayColor
              }, null, 8, ["size", "fill-color"]))
            : (_openBlock(), _createBlock(_component_NcIconSvgWrapper, {
                key: 1,
                inline: "",
                svg: $setup.IconMicrophoneOffOutline,
                size: $props.size,
                style: _normalizeStyle({ color: $props.overlayMutedColor })
              }, null, 8, ["svg", "size", "style"]))
        ], 6))
      : _createCommentVNode("", true)
  ], 6))
}